var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMergeImages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9217_303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1395 78.7158C14.2494 58.5052 38.3189 43.2752 66.7157 33.7036C95.3056 24.0669 131.3 18.6511 164.075 28.1778C195.098 37.1953 206.435 58.469 217.285 77.4696C227.178 94.7956 239.339 115.202 220.957 127.794C203.642 139.654 169.178 129.687 140.969 129.745C114.864 129.798 89.1158 137.328 66.2025 128.109C37.4903 116.557 14.0352 97.8996 14.1395 78.7158Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.214 69.4545C132.214 69.9736 131.793 70.3945 131.274 70.3945L120.94 70.3945C120.421 70.3945 120 70.8153 120 71.3345L120 87.2955C120 87.8147 120.421 88.2355 120.94 88.2355L131.274 88.2355C131.793 88.2355 132.214 88.6564 132.214 89.1755L132.214 93.4321C132.214 94.308 133.307 94.7079 133.872 94.039L145.807 79.9219C146.103 79.5715 146.103 79.0585 145.807 78.7081L133.872 64.591C133.307 63.9221 132.214 64.322 132.214 65.1979L132.214 69.4545Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 128.298V29.7312C161.64 26.9024 163.864 24.6397 166.57 24.6397H224.038L247.293 48.5665V128.298C247.293 131.127 245.069 133.39 242.363 133.39H166.57C163.865 133.39 161.64 131.128 161.64 128.298Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.867,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.867,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.004 116.727V105.273H194.205C195.476 105.273 196.456 105.598 197.145 106.248C197.834 106.887 198.179 107.78 198.179 108.928C198.179 110.076 197.834 110.975 197.145 111.625C196.456 112.275 195.476 112.6 194.205 112.6H191.508V116.727H189.004ZM191.508 110.651H193.785C195.11 110.651 195.772 110.076 195.772 108.928C195.772 107.802 195.11 107.239 193.785 107.239H191.508V110.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.731 116.727V105.273H204.189C206.127 105.273 207.63 105.771 208.696 106.768C209.762 107.753 210.295 109.161 210.295 110.992C210.295 112.822 209.762 114.236 208.696 115.232C207.63 116.229 206.127 116.727 204.189 116.727H199.731ZM202.235 114.663H204.044C206.467 114.663 207.678 113.44 207.678 110.992C207.678 108.555 206.467 107.336 204.044 107.336H202.235V114.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24 116.727V105.273H219.929V107.239H214.744V110.033H219.574V111.999H214.744V116.727H212.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.235 42.6789V25.5814L246.491 47.5552H229.931C227.358 47.5552 225.235 45.3929 225.235 42.6789Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182 56.6251H228C228.751 56.6251 229.36 57.2341 229.36 57.9854V61.6007C229.36 62.352 228.751 62.961 228 62.961H182C181.249 62.961 180.64 62.352 180.64 61.6007V57.9854C180.64 57.2341 181.249 56.6251 182 56.6251Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 69.3174H228C228.751 69.3174 229.36 69.9265 229.36 70.6777V74.2931C229.36 75.0444 228.751 75.6534 228 75.6534H182C181.249 75.6534 180.64 75.0444 180.64 74.2931V70.6777C180.64 69.9265 181.249 69.3174 182 69.3174Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 82.0098H228C228.751 82.0098 229.36 82.6188 229.36 83.3701V86.9855C229.36 87.7367 228.751 88.3458 228 88.3458H182C181.249 88.3458 180.64 87.7367 180.64 86.9855V83.3701C180.64 82.6188 181.249 82.0098 182 82.0098Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.452174 98.7228V29.0511C0.452174 27.0519 2.02516 25.4522 3.94035 25.4522H44.5928L61.0432 42.3648V98.7228C61.0432 100.722 59.4702 102.322 57.555 102.322H3.94035C2.02593 102.322 0.452174 100.723 0.452174 98.7228Z",
    fill: "white",
    stroke: "#5F30E2",
    strokeWidth: 0.904348
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.04346,
    y: 44.8955,
    width: 43.4087,
    height: 25.3217,
    rx: 1.8087,
    fill: "#FCEDF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.374 57.1126L18.2482 54.5519C19.7434 53.2197 21.997 53.2961 23.402 54.7266L30.4409 61.8938C31.5685 63.042 33.3436 63.1986 34.6484 62.2649L35.1377 61.9148C37.0152 60.5712 39.5555 60.7269 41.2612 62.29L46.5506 67.1373",
    stroke: "#5F30E2",
    strokeWidth: 2.24279,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 42.986,
    cy: 52.819,
    rx: 3.61739,
    ry: 3.73015,
    stroke: "#5F30E2",
    strokeWidth: 2.24279
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.23486,
    y: 75.6436,
    width: 47.0261,
    height: 19.8957,
    rx: 2.42882,
    fill: "#5F30E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5351 89.0913V81.4405H15.2497V89.0913H13.5351ZM16.8845 89.0913V81.4405H18.4038L21.0626 86.3674H20.7804L23.4283 81.4405H24.9151V89.0913H23.3632V84.0233H23.5369L21.3881 87.9193H20.4114L18.2519 84.0233H18.4472V89.0913H16.8845ZM25.6808 89.0913L29.1969 81.4405H30.5968L34.1129 89.0913H32.3766L31.465 86.9643L32.1595 87.4743H27.6233L28.307 86.9643L27.4063 89.0913H25.6808ZM29.8806 83.2311L28.4806 86.5519L28.1985 86.1287H31.5952L31.3022 86.5519L29.9023 83.2311H29.8806ZM38.4543 89.2107C37.6006 89.2107 36.8771 89.0515 36.2838 88.7332C35.6906 88.4076 35.2348 87.9518 34.9165 87.3658C34.6054 86.7798 34.4498 86.0853 34.4498 85.2822C34.4498 84.4719 34.609 83.7701 34.9273 83.1769C35.2529 82.5836 35.7195 82.1278 36.3273 81.8095C36.935 81.4839 37.6585 81.3212 38.4977 81.3212C38.8667 81.3212 39.2175 81.3537 39.5503 81.4188C39.8904 81.4839 40.2051 81.5816 40.4945 81.7118C40.7839 81.8348 41.0299 81.9831 41.2324 82.1568L40.6898 83.4699C40.3498 83.2311 40.0025 83.0611 39.648 82.9598C39.3007 82.8513 38.9245 82.797 38.5194 82.797C37.767 82.797 37.1954 83.0105 36.8047 83.4373C36.4141 83.8569 36.2187 84.4719 36.2187 85.2822C36.2187 86.0997 36.4141 86.7183 36.8047 87.1379C37.2027 87.5575 37.7851 87.7673 38.5519 87.7673C38.8341 87.7673 39.1126 87.742 39.3876 87.6914C39.6697 87.6407 39.941 87.5684 40.2015 87.4743L39.8759 88.1689V86.0853H38.2372V84.8373H41.2867V88.6247C41.0407 88.7477 40.7622 88.8526 40.4511 88.9394C40.14 89.0262 39.8144 89.0913 39.4744 89.1347C39.1343 89.1854 38.7943 89.2107 38.4543 89.2107ZM42.8592 89.0913V81.4405H48.1551V82.7862H44.5088V84.5334H47.9164V85.8791H44.5088V87.7456H48.1551V89.0913H42.8592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3911 38.2031V26.1172L60.4284 41.6499H48.7135C46.8927 41.6499 45.3911 40.1211 45.3911 38.2031Z",
    fill: "white",
    stroke: "#5F30E2",
    strokeWidth: 0.904348
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3911 124.949V55.2772C29.3911 53.278 30.9641 51.6782 32.8793 51.6782H73.5318L89.9822 68.5909V124.949C89.9822 126.948 88.4092 128.548 86.494 128.548H32.8793C30.9649 128.548 29.3911 126.949 29.3911 124.949Z",
    fill: "white",
    stroke: "#5F30E2",
    strokeWidth: 0.904348
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.9824,
    y: 71.1216,
    width: 43.4087,
    height: 25.3217,
    rx: 1.8087,
    fill: "#FCEDF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.313 83.3386L47.1871 80.7779C48.6824 79.4457 50.936 79.5221 52.3409 80.9527L59.3798 88.1199C60.5075 89.2681 62.2826 89.4247 63.5874 88.491L64.0767 88.1408C65.9542 86.7973 68.4944 86.9529 70.2002 88.5161L75.4896 93.3633",
    stroke: "#5F30E2",
    strokeWidth: 2.24279,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 71.925,
    cy: 79.0451,
    rx: 3.61739,
    ry: 3.73015,
    stroke: "#5F30E2",
    strokeWidth: 2.24279
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.1738,
    y: 101.87,
    width: 47.0261,
    height: 19.8957,
    rx: 2.42882,
    fill: "#5F30E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.474 115.317V107.667H44.1887V115.317H42.474ZM45.8234 115.317V107.667H47.3427L50.0015 112.593H49.7194L52.3673 107.667H53.8541V115.317H52.3022V110.249H52.4758L50.3271 114.145H49.3504L47.1908 110.249H47.3862V115.317H45.8234ZM54.6197 115.317L58.1358 107.667H59.5358L63.0519 115.317H61.3155L60.4039 113.19L61.0985 113.7H56.5623L57.246 113.19L56.3452 115.317H54.6197ZM58.8195 109.457L57.4196 112.778L57.1374 112.355H60.5342L60.2412 112.778L58.8412 109.457H58.8195ZM67.3932 115.437C66.5395 115.437 65.8161 115.278 65.2228 114.959C64.6296 114.634 64.1738 114.178 63.8554 113.592C63.5443 113.006 63.3888 112.311 63.3888 111.508C63.3888 110.698 63.548 109.996 63.8663 109.403C64.1919 108.81 64.6585 108.354 65.2662 108.036C65.8739 107.71 66.5974 107.547 67.4367 107.547C67.8056 107.547 68.1565 107.58 68.4893 107.645C68.8293 107.71 69.1441 107.808 69.4335 107.938C69.7228 108.061 69.9688 108.209 70.1714 108.383L69.6288 109.696C69.2888 109.457 68.9415 109.287 68.587 109.186C68.2397 109.077 67.8635 109.023 67.4584 109.023C66.7059 109.023 66.1344 109.237 65.7437 109.663C65.353 110.083 65.1577 110.698 65.1577 111.508C65.1577 112.326 65.353 112.944 65.7437 113.364C66.1416 113.784 66.724 113.993 67.4909 113.993C67.7731 113.993 68.0516 113.968 68.3265 113.917C68.6087 113.867 68.88 113.794 69.1404 113.7L68.8149 114.395V112.311H67.1762V111.063H70.2257V114.851C69.9797 114.974 69.7011 115.079 69.39 115.165C69.0789 115.252 68.7534 115.317 68.4133 115.361C68.0733 115.411 67.7333 115.437 67.3932 115.437ZM71.7982 115.317V107.667H77.0941V109.012H73.4477V110.759H76.8553V112.105H73.4477V113.972H77.0941V115.317H71.7982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3306 64.4292V52.3432L89.3678 67.876H77.653C75.8321 67.876 74.3306 66.3472 74.3306 64.4292Z",
    fill: "white",
    stroke: "#5F30E2",
    strokeWidth: 0.904348
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9217_303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 159,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMergeImages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge_images.3ef5cae077edea60fdee627395278a3b.svg";